import React from 'react';
import { ACCENT_COLOR } from './colors';

const AbstractLeft = ({
  width = 286,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width / 1.5376344086021505}
    viewBox="0 0 286 186"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M90 184L284 0" stroke="#E5E5E6" strokeWidth="2" strokeLinecap="square" />
    <circle r="160" fill="#FFCC66" />
    <path d="M40 40L170 180L200 108L40 40Z" fill={ACCENT_COLOR} />
  </svg>
);

export default AbstractLeft;
